/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCustomDefaultLeadViewSetting404Response } from '../models';
// @ts-ignore
import { PostProductRequest } from '../models';
// @ts-ignore
import { Product } from '../models';
// @ts-ignore
import { PutProductRequest } from '../models';
/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定した商材カテゴリに商材を作成するAPI
         * @summary 商材作成API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {PostProductRequest} postProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProduct: async (productCategoryId: number, postProductRequest: PostProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCategoryId' is not null or undefined
            assertParamExists('postProduct', 'productCategoryId', productCategoryId)
            // verify required parameter 'postProductRequest' is not null or undefined
            assertParamExists('postProduct', 'postProductRequest', postProductRequest)
            const localVarPath = `/api/user/product_categories/{productCategoryId}/products`
                .replace(`{${"productCategoryId"}}`, encodeURIComponent(String(productCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した商材カテゴリ配下の商材名を更新するAPI（レスポンスボディなし）。 商材カテゴリが存在しない場合、または商材が当該カテゴリに属さない場合は404となる。 
         * @summary 商材更新API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {number} productId 商材ID
         * @param {PutProductRequest} putProductRequest 商材更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProduct: async (productCategoryId: number, productId: number, putProductRequest: PutProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCategoryId' is not null or undefined
            assertParamExists('putProduct', 'productCategoryId', productCategoryId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('putProduct', 'productId', productId)
            // verify required parameter 'putProductRequest' is not null or undefined
            assertParamExists('putProduct', 'putProductRequest', putProductRequest)
            const localVarPath = `/api/user/product_categories/{productCategoryId}/products/{productId}`
                .replace(`{${"productCategoryId"}}`, encodeURIComponent(String(productCategoryId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定した商材カテゴリに商材を作成するAPI
         * @summary 商材作成API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {PostProductRequest} postProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postProduct(productCategoryId: number, postProductRequest: PostProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postProduct(productCategoryId, postProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した商材カテゴリ配下の商材名を更新するAPI（レスポンスボディなし）。 商材カテゴリが存在しない場合、または商材が当該カテゴリに属さない場合は404となる。 
         * @summary 商材更新API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {number} productId 商材ID
         * @param {PutProductRequest} putProductRequest 商材更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putProduct(productCategoryId: number, productId: number, putProductRequest: PutProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putProduct(productCategoryId, productId, putProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * 指定した商材カテゴリに商材を作成するAPI
         * @summary 商材作成API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {PostProductRequest} postProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProduct(productCategoryId: number, postProductRequest: PostProductRequest, options?: any): AxiosPromise<Product> {
            return localVarFp.postProduct(productCategoryId, postProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した商材カテゴリ配下の商材名を更新するAPI（レスポンスボディなし）。 商材カテゴリが存在しない場合、または商材が当該カテゴリに属さない場合は404となる。 
         * @summary 商材更新API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {number} productId 商材ID
         * @param {PutProductRequest} putProductRequest 商材更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProduct(productCategoryId: number, productId: number, putProductRequest: PutProductRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putProduct(productCategoryId, productId, putProductRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApi - interface
 * @export
 * @interface ProductApi
 */
export interface ProductApiInterface {
    /**
     * 指定した商材カテゴリに商材を作成するAPI
     * @summary 商材作成API
     * @param {number} productCategoryId 商材カテゴリID
     * @param {PostProductRequest} postProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    postProduct(productCategoryId: number, postProductRequest: PostProductRequest, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * 指定した商材カテゴリ配下の商材名を更新するAPI（レスポンスボディなし）。 商材カテゴリが存在しない場合、または商材が当該カテゴリに属さない場合は404となる。 
     * @summary 商材更新API
     * @param {number} productCategoryId 商材カテゴリID
     * @param {number} productId 商材ID
     * @param {PutProductRequest} putProductRequest 商材更新リクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    putProduct(productCategoryId: number, productId: number, putProductRequest: PutProductRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for postProduct operation in ProductApi.
 * @export
 * @interface ProductApiPostProductRequest
 */
export interface ProductApiPostProductRequest {
    /**
     * 商材カテゴリID
     * @type {number}
     * @memberof ProductApiPostProduct
     */
    readonly productCategoryId: number

    /**
     * 
     * @type {PostProductRequest}
     * @memberof ProductApiPostProduct
     */
    readonly postProductRequest: PostProductRequest
}

/**
 * Request parameters for putProduct operation in ProductApi.
 * @export
 * @interface ProductApiPutProductRequest
 */
export interface ProductApiPutProductRequest {
    /**
     * 商材カテゴリID
     * @type {number}
     * @memberof ProductApiPutProduct
     */
    readonly productCategoryId: number

    /**
     * 商材ID
     * @type {number}
     * @memberof ProductApiPutProduct
     */
    readonly productId: number

    /**
     * 商材更新リクエストボディ
     * @type {PutProductRequest}
     * @memberof ProductApiPutProduct
     */
    readonly putProductRequest: PutProductRequest
}

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI implements ProductApiInterface {
    /**
     * 指定した商材カテゴリに商材を作成するAPI
     * @summary 商材作成API
     * @param {ProductApiPostProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public postProduct(requestParameters: ProductApiPostProductRequest, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).postProduct(requestParameters.productCategoryId, requestParameters.postProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した商材カテゴリ配下の商材名を更新するAPI（レスポンスボディなし）。 商材カテゴリが存在しない場合、または商材が当該カテゴリに属さない場合は404となる。 
     * @summary 商材更新API
     * @param {ProductApiPutProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public putProduct(requestParameters: ProductApiPutProductRequest, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).putProduct(requestParameters.productCategoryId, requestParameters.productId, requestParameters.putProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
